<template>
	<v-dialog
		v-model="dialog"
		max-width="800px"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<template v-slot:activator="{ on, attrs }">
			<v-btn color="secondary" class="ml-2" v-bind="attrs" v-on="on">
				<v-icon class="mr-1">mdi-file-document-plus-outline</v-icon>
				資料添付
			</v-btn>
		</template>

		<v-card tile>
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white">資料添付</v-app-bar-title>
				<v-spacer />
				<v-btn icon dark @click="closeDialog" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-app-bar>

			<div class="pa-4">
				<DragUpload @fileShare="fileShare" :attached_files="attached_files" ref="update" />
			</div>
		</v-card>
	</v-dialog>
</template>

<script>
import DragUpload from "../../shared/DragUpload.vue"
export default {
	components: {
		DragUpload,
	},
	data() {
		return {
			dialog: false,
			attached_files: [],
			uploadFiles: [],
		}
	},
	methods: {
		fileShare(file) {
			this.uploadFiles = file
			this.$emit("uploadFiles", this.uploadFiles)
			this.closeDialog()
		},
		closeDialog() {
			this.dialog = false
			this.$refs.update.resetFiles()
		},
	},
}
</script>
